jQuery(document).on("swup:pageView", function () {
  $ = jQuery;

  if ($("main.about").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    /*****************************************************************
      Team Slider
    ******************************************************************/
    var teamSlider = $(".team .owl-carousel");
    teamSlider
      .owlCarousel({
        autoplay: false,
        loop: false,
        nav: true,
        navContainer: ".prop-controls",
        navElement: "div",
        navText: ["", ""],
        items: 1,
        margin: 0,
        slideBy: 1,
        rewind: true,
        rewindNav: true,
        rewindSpeed: 0,
        dots: false,
        autoHeight: true,
        lazyLoad: true,
        checkVisibility: false,
        responsive: {
          768: {
            items: 3,
          },
          950: {
            items: 3,
          },
          1200: {
            items: 3,
          },
        },
        onInitialized: function (e) {
          var totalCount = $(teamSlider).parents(".container").find(".slide-num-contain .nums-total");
          var currentCount = $(teamSlider).parents(".container").find(".slide-num-contain .nums-count");
          // totalCount.text("0" + e.item.count);

          var spacerItemsReducer = 2;
          if (isMobile) {
            spacerItemsReducer = 0;
          }

          totalCount.text("0" + (e.item.count - spacerItemsReducer));

          currentCount.text("0" + (e.item.index + 1));
        },
      })
      .on("changed.owl.carousel", function (e) {
        var currentCount = $(teamSlider).parents(".container").find(".slide-num-contain .nums-count");
        currentCount.text("0" + (e.item.index + 1));
      });

    $(window).on("resize", function () {
      $(".team .owl-carousel .owl-stage-outer").width(innerWidth);
    });

    /*****************************************************************
      Value Slider Mobile
    ******************************************************************/
    var valueSlider = $(".value-slider-mobile .owl-carousel");
    valueSlider.owlCarousel({
      autoplay: false,
      loop: true,
      nav: false,
      items: 1,
      margin: 0,
      slideBy: 1,
      dots: true,
      autoHeight: false,
      lazyLoad: true,
      checkVisibility: false,
    });
  }
});
